<template>
  <div class='backup-wrapper'>
      <b-tabs pills class="h-100" v-model="tabIndex">
        <b-tab class="h-100">
          <template slot="title">
            <span class="title-header">Manage</span>
          </template>
          <div class="custom-tab" v-if="tabIndex == 0">
          <site-selector class="mt-3" :selected.sync="sites" :noheader="true" :selectall="false"></site-selector>
            <div class="custom-tab-header plugins-themes">
              <b-row>
                <b-col>
                  <div class="d-flex align-items-center">
                    <b-form-group class="mode-group dark">
                      <b-form-radio-group button-variant="outline-custom" buttons v-model="currentTabIndex" @change="changeType" :options="switches" class="active"></b-form-radio-group>
                    </b-form-group>
                    <b-form-select class="primary-select ml-2"  v-if="currentTabIndex == 'plugins'" v-model="viewType" :options="pluginOptions" />
                    <b-form-select class="primary-select ml-2"  v-else v-model="viewType" :options="themeOptions" />
                    <span class="label ml-2">By status:</span>
                    <b-form-group class="mode-group ml-2">
                      <b-form-radio-group button-variant="outline-custom" buttons v-model="isActivated" :options="options" class="active"></b-form-radio-group>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="custom-tab-body hasfooter">
                <entity-manager :searchtext.sync="search" :viewType="viewType" :entities="pluginsAndThemes[currentTabIndex]" @selectAll="select" :type="currentTabIndex" :isActivated="isActivated">
                </entity-manager>
            </div>
          </div>
        </b-tab>
        <b-tab class="h-100 installer-modal">
          <template slot="title">
            <span class="title-header">Install</span>
          </template>
          <div class="custom-tab" v-if="tabIndex == 1">
          <site-selector class="mt-3" :selected.sync="sites" :noheader="true"></site-selector>
            <div class="custom-tab-header plugins-themes">
              <b-row>
                <b-col>
                  <div class="d-flex align-items-center">
                    <b-form-group class="mode-group dark">
                      <b-form-radio-group button-variant="outline-custom" buttons v-model="currentTabIndex" @change="changeType" :options="switches" class="active"></b-form-radio-group>
                    </b-form-group>
                    <span class="label ml-2">Install from:</span>
                    <b-form-group class="mode-group ml-2">
                      <b-form-radio-group button-variant="outline-custom" buttons v-model="installSwitch" :options="installOptions" class="active"></b-form-radio-group>
                    </b-form-group>
                  </div>
                </b-col>
                <div class="relative mr-2 p-0" v-if="installSwitch==='wprepoinstaller'">
                  <b-input class="mb-2 mr-sm-2 mb-sm-0 search-input wp-repo float-right" v-model="searchText" debounce="500" id="search_text" type="text" placeholder="Search sites" />
                  <div class="search-icon-container wp-repo">
                    <magnifier-icon class="icon-default search-icon"></magnifier-icon>
                  </div>
                </div>
              </b-row>
            </div>
            <div class="custom-tab-body hasfooter no-scroll">
              <component :is="installSwitch" :sites="sites" :type="currentTabIndex" @onInstall="install" @gotoWpRepo="gotoWpRepo" :searchText="searchText" @addFavorite="addFavorite"></component>
            </div>
          </div>
        </b-tab>
      </b-tabs>

  </div>

  </template>

<script>
import Vue from "vue";

import utilsMixin from "../../mixins/utils";
import MagnifierIcon from "../../assets/lens.svg";
import InstallPluginsAndThemes from "../Manage/InstallPluginsAndThemes";

import EntityManager from "../Manage/EntityManager";
import EmptyPlaceholder from "../Common/EmptyPlaceholder";
import SiteSelector from '../Common/SiteSelectorInPage';
import favoriteinstaller from '../Manage/FavoriteInstaller';
import wprepoinstaller from '../Manage/WpRepoInstaller';
import mycomputerinstaller from '../Manage/MyComputerInstaller';
import urlinstaller from '../Manage/URLInstaller';


export default {
  name: "pluginsandthemes",
  mixins: [utilsMixin],
  mounted() {
    //this.showInstallPluginsModal();
  },
  components: {
    InstallPluginsAndThemes,
    MagnifierIcon,
    EntityManager,
    EmptyPlaceholder,
    SiteSelector,
    favoriteinstaller,
    wprepoinstaller,
    mycomputerinstaller,
    urlinstaller,
  },
  data() {
    return {
      plugins: [],
      sites: [],
      tabIndex: 0,
      currentTabIndex: 'plugins',
      selectAllPlugins: false,
      selectAllThemes: false,
      search: "",
      isActivated: true,
      installSwitch: 'favoriteinstaller',
      options: [
        { text: "Active", value: true },
        { text: "Inactive", value: false }
      ],
      installOptions: [
        { text: 'My favorites', value: 'favoriteinstaller' },
        { text: 'WP Repository', value: 'wprepoinstaller' },
        { text: 'My Computer', value: 'mycomputerinstaller' },
        { text: 'URL', value: 'urlinstaller' }
      ],
      switches:[
        { text: "Plugins", value: 'plugins' },
        { text: "Themes", value: 'themes' }
      ],
      pluginOptions: [
        { text: "Websites", value: 'all' },
        { text: "Plugins", value: 'plugins' }
      ],
      themeOptions: [
        { text: "Websites", value: 'all' },
        { text: "Themes", value: 'themes' }
      ],
      viewType : 'all',
      searchText: '',
    };
  },
  computed: {
    getSites() {
      return this.$store.getters.getSites;
    },
    getSelectedSites() {
      return this.$store.getters.selectedSites;
    },
    getPluginsAndThemes() {
      return this.$store.getters.getPluginsAndThemes;
    },
    rawPluginsAndThemes() {
      let sitePluginsAndThemes = [];
      let updates = [];
      sitePluginsAndThemes = _.filter(this.$store.getters.getPluginsAndThemes, siteUpdate => {
        if (siteUpdate.isActivated == this.isActivated && siteUpdate.type == this.currentTabIndex) {
          let siteId = siteUpdate.siteID;
          let site = this.getSites[siteId];
          let findSelecetedSiteID = this.sites.indexOf(siteId) > -1;
          let itemPresent = true;
          if (this.viewType != 'all') {
            itemPresent = siteUpdate.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 
          }else{
            itemPresent = site.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
          }
          if (site && findSelecetedSiteID && itemPresent) {
            let item = Object.assign({}, siteUpdate, { siteName: site.name });
            return updates.push(item);
          }
        }
      });
      return updates;
    },
    pluginsAndThemes() {
      let updates = this.rawPluginsAndThemes;
      let groupType = 'URI';
      let groupSort = '';
      let processedPluginsAndThemes = {
        plugins: [],
        themes: []
      };
      if (this.viewType == 'all' ) {
          groupType = 'siteName';
          groupSort = _.sortBy(updates, [data => data.siteName.toLowerCase()]);
      }else{
          groupSort = _.sortBy(updates, [data => data.name.toLowerCase()]);
      }
      let groupByType = _.groupBy(groupSort, "type");
      _.each(groupByType, (group, key) => {
        processedPluginsAndThemes[key] = _.chain(group)
          .groupBy(groupType)
          .toPairs()
          .map(function(currentItem) {
            if (groupType == 'siteName' ) {
              currentItem.push(currentItem[1][0].siteName);
            }else{
              currentItem.push(currentItem[1][0].name);
            }
            let showEntity = false;
            return _.zipObject(["URI", "sites", "name", "showEntity"], currentItem);
          })
          .value();
      });
      return processedPluginsAndThemes;
    },
    settings() {
      return this.$store.getters.getSettings;
    }
  },
  watch: {
     viewType(){
       this.select({type: this.currentTabIndex, value: 0});
     }
   },
  methods: {
    select(payload) {
      let sites = _.filter(this.rawPluginsAndThemes, { type: payload.type });
      this.$store.commit({
        type: "SELECT_GROUP_PLUGINS_AND_THEMES",
        sites: sites,
        value: payload.value
      });
    },

    tabSelected(index) {
      this.currentTabIndex = index;
    },
    showInstallPluginsModal() {
      this.$refs.installPluginsAndThemes.$refs.installPluginsAndThemesModal.show();
    },
    changeType(){
      this.viewType = "all";
    },
    install(event) {
      let payload = {};
      payload.action = `install${this.capitalizeFirstLetter(event.type)}`;
      let selectedItems = event.selectedItems;
      let selectedSiteIds = this.sites;
      payload.args = {};
      payload.args.params = {};
      payload.args.siteIDs = selectedSiteIds;
      let paramsArray = [];
      _.each(selectedItems, selectedItem => {
        let formatedURL = '';
        if(this.settings.appSettings.httpAuth!=undefined && this.installSwitch == 'mycomputerinstaller')
        {
          if(this.settings.appSettings.httpAuth.username!='' && this.installSwitch == 'mycomputerinstaller'){
            formatedURL=selectedItem.replace("://","://"+this.settings.appSettings.httpAuth.username+":"+this.settings.appSettings.httpAuth.password+"@");
          }
        }else{

          formatedURL = selectedItem;
        }
        paramsArray.push(formatedURL);
      });
      payload.args.params[this.currentTabIndex] = paramsArray;
      if (event.activate) {
        payload.args.params['activate'] = event.activate;
      }
      if (event.clearDestination) {
        payload.args.params['clearDestination'] = event.clearDestination;
      }
      payload.requiredData = {};
      payload.requiredData['getPluginsAndThemesV3'] = 1;
      if (event.addFavourites) {
        payload.requiredData.addFavourites = event.addFavourites;
      }
      this.$store
        .dispatch('sendAction', payload)
        .then(() => {
          
          this.$emit('close');
        })
        .catch(err => {
          
        });
    },
    gotoWpRepo() {
      this.installer = 'wprepoinstaller';
    },
    addFavorite(event) {
      let payload = {};
      payload.requiredData = {
        addFavourites: event,
        getFavouritesPluginsAndThemesV3: 1
      };
      this.$store
        .dispatch('sendAction', payload)
        .then(response => {
          this.$store.commit(
            'SET_FAVORITES',
            response.data.getFavouritesPluginsAndThemesV3
          );
          
        })
        .catch(err => {
          
        });
    }
  }
};
</script>

<style scoped>

</style>
